import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AppMainComponent } from 'src/app/app.main.component';
import { jsPDF } from "jspdf";
import { RobotoFont } from 'src/app/inventory/sales-order/utils/vfs';
import { TaxSplitService } from '../products-tax-split-view/service/tax-split.service';
import { TaxCountry } from 'src/app/inventory/sales-order/constants/constants';


@Component({
    selector: 'app-billing-print',
    templateUrl: './billing-print.component.html',
    styleUrl: './billing-print.component.scss'
})
export class BillingPrintComponent implements OnChanges {
  
    @Input() length: number = 0;
    @Input() baseCurrency;
    @Input() qtyDecimal: number = 0;
    @Input() billTemplate;
    @Input() billPrintDetails;
    @Input() companyInfo;
    @Input() footerTaxEnabled: boolean = false;
    lineTotal: number = 0;
    showTaxBasedSplitView = false;
    isStateMatched = false;
    taxBasedProductsList = [];
    taxBasedProductsCols = [];
    elementType = 'img';
    format = 'CODE128';
    lineColor = '#000000';
    width = 1;
    height = 20;
    displayValue = true;
    fontOptions = '';
    font = 'monospace';
    textAlign = 'center';
    textPosition = 'bottom';
    textMargin = 2;
    fontSize = 10;
    background = '#ffffff';
    margin = 10;
    marginTop = 10;
    marginBottom = 10;
    marginLeft = 0;
    marginRight = 10;


    constructor(public app: AppMainComponent, private taxSplitService: TaxSplitService) { }


    ngOnChanges(changes: SimpleChanges) {
        if(changes.billTemplate?.currentValue){
            this.footerTaxEnabled = !this.billTemplate?.labels_table[5]?.IsPrint;
        }

        if(changes.billPrintDetails?.currentValue){
            this.lineTotal = this.billPrintDetails?.items?.reduce((acc, item) => acc + item.lineTotal, 0);
            this.checkCountryToShowSplitView();
        }
    }

    print() {
        let pdf = new jsPDF("p", "pt", "a4", true);
        pdf.addFileToVFS('Roboto-Regular.ttf', RobotoFont);
        pdf.addFont('Roboto-Regular.ttf', 'Roboto-Regular', 'normal');
        pdf.setFont('Roboto-Regular');

        let html = document.getElementById("billPreview").innerHTML;
        html = html.replace(/width="100%"/, 'width="555"');
        let pdfFileName = `Bill${this.billPrintDetails?.selectedBill?.billno}`;
        pdf.setProperties({ title: pdfFileName + ".pdf" });
        pdf.html(html, {
            callback: function (pdf) {
                const dataUri = pdf.output("datauristring");
                const newTab = window.open();
                newTab.document.write('<iframe width="100%" height="100%" src="' + dataUri + '" type="application/pdf"></iframe>');
                newTab.document.title = pdfFileName + ".pdf";
            },
            margin: [40, 20],
        });
        return pdf;
    }

    getPDF() {
        let pdf = new jsPDF("p", "pt", "a4", true);
        pdf.addFileToVFS('Roboto-Regular.ttf', RobotoFont);
        pdf.addFont('Roboto-Regular.ttf', 'Roboto-Regular', 'normal');
        pdf.setFont('Roboto-Regular');

        let html = document.getElementById("billPreview").innerHTML;
        html = html.replace(/width="100%"/, 'width="555"');
        pdf.html(html, {
            margin: [40, 20],
        });
        return pdf;
    }
    checkCountryToShowSplitView() {
 
          const billOrderProducts = this.billPrintDetails?.savedBill?.billOrderProducts?.map(item => ({
            ...item,
            itemNo: item.product?.itemNo,
            hsnsac: item.product?.hsnsac
          }));

        if (this.billPrintDetails?.savedBill?.warehouse?.address?.countryId == TaxCountry.India) {
            if (this.billPrintDetails?.savedBill?.shippingAddress?.countryId == this.billPrintDetails?.savedBill?.warehouse?.address?.countryId
               && this.billPrintDetails?.savedBill?.shippingAddress?.address?.state?.name?.toLowerCase() == this.billPrintDetails?.savedBill?.warehouse?.address?.state?.name?.toLowerCase()) {
              this.isStateMatched = true;
            } else {
              this.isStateMatched = false;
            }
            this.showTaxBasedSplitView = true;
          } else {
            this.showTaxBasedSplitView = false;
          }
        if(this.showTaxBasedSplitView){
            const taxSplitObj = this.taxSplitService.prepareTaxBasedProductsList(billOrderProducts, 'Bill Order', this.isStateMatched);
            this.taxBasedProductsCols = taxSplitObj?.taxBasedProductsCols;
            this.taxBasedProductsList = taxSplitObj?.taxBasedProductsList;
        }
    }
}
